<template>
  <div id="app">
    <the-header></the-header>
    <the-content></the-content>
    <the-footer></the-footer>
  </div>
</template>

<script>
import TheContent from './components/TheContent'
import TheHeader from './components/TheHeader'
import TheFooter from './components/TheFooter'

export default {
  name: 'App',
  components: {TheContent, TheHeader, TheFooter},
  metaInfo: {
    titleTemplate: '%s | Ювелирная фирма «Стиль»'
  }
}
</script>

<style lang="scss">
  body {
    background-color: $default-background-color;
    width: 100%;
    height: 100vh;
    overflow: auto;
    margin: 0;
  }
  #app {
    font-family: $font-stack;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: $default-text-color;
    @include media(">tablet") { font-size: 13px; }
  }
  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    color: $default-heading-color;
  }
  h1, h2 {
    font-family: "Cormorant Light", $font-stack;
    letter-spacing: 0.2em;
    text-transform: uppercase;
  }
  h1 {
    @include media(">tablet") { font-size: 2em; }
    @include media("<=tablet") { font-size: 1.5em; }
    @include media(">desktop") { margin-bottom: 1em; }
    @include media("<=desktop") { margin-bottom: 0.67em; }
  }
  h2 {
    @include media(">tablet") { font-size: 1.5em; }
    @include media("<=tablet") { font-size: 1.25em; }
  }
  section, article, aside, footer, header, nav, main, hgroup {
    display: block;  /* HTML5 elements support for old browsers */
  }
  figure {
    margin: 0;
  }
  p {
    margin: 0 0 1em 0;
    line-height: 1.625;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: $default-link-color;
    cursor: pointer;
    transition: color 0.4s;
    &:hover { color: $active-link-color; }
  }
  img[lazy=loaded] {
    opacity: 1;
    transition: opacity 0.5s;
  }
  img[lazy=loading] {
    opacity: 0;
  }
  @media only print {
    body {
      overflow: visible;
    }
    *,
    *:before,
    *:after,
    *:first-letter,
    p:first-line,
    div:first-line,
    blockquote:first-line,
    li:first-line {
      background: transparent !important;
      color: #000 !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }
    a:after {
      content: " (" attr(href) ") ";
    }
    a[href^="tel:"],
    a[href^="viber:"],
    a[href^="mailto:"] {
      &:after {
        content: "" !important;
      }
    }
    img[lazy=loading] {
      opacity: 1 !important;
    }
    /* page specific styles */
    @page {
      margin: 2cm;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue